import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareReadOnlyAttributePropertyValues =
    AttributePropertyValues
    & {
    };

export type ClientAwareReadOnlyAttributeProperties = {
    [name in keyof ClientAwareReadOnlyAttributePropertyValues]?: ClientAwareReadOnlyAttributePropertyValues[name];
};

export interface IClientAwareReadOnlyAttribute extends IAttribute, ClientAwareReadOnlyAttributeProperties
{
}

export class ClientAwareReadOnlyAttribute extends Attribute implements IClientAwareReadOnlyAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareReadOnlyAttribute";
    public static override className = "ClientAwareReadOnlyAttribute";
}